import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-cdb45a36"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "productos-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "productos-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Agregar Producto", -1 /* HOISTED */));
const _hoisted_6 = { class: "search-container" };
const _hoisted_7 = { class: "table-container" };
const _hoisted_8 = { class: "productos-table" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Portada"),
        /*#__PURE__*/ _createElementVNode("th", null, "Producto"),
        /*#__PURE__*/ _createElementVNode("th", null, "Cód. Barras Ref."),
        /*#__PURE__*/ _createElementVNode("th", null, "Código Único"),
        /*#__PURE__*/ _createElementVNode("th", null, "Precio de Venta"),
        /*#__PURE__*/ _createElementVNode("th", null, "Activo"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_10 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner" }, null, -1 /* HOISTED */));
const _hoisted_12 = [
    _hoisted_11
];
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = { style: { "display": "flex", "flex-direction": "column", "gap": "4px" } };
const _hoisted_15 = { class: "precio" };
const _hoisted_16 = {
    key: 0,
    style: { "background": "#fef2f2", "color": "#ef4444", "font-size": "0.7rem", "font-weight": "700", "padding": "2px 6px", "border-radius": "4px", "width": "fit-content", "display": "flex", "align-items": "center", "gap": "3px" }
};
const _hoisted_17 = { class: "switch" };
const _hoisted_18 = ["checked", "onChange"];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "slider" }, null, -1 /* HOISTED */));
const _hoisted_20 = { class: "actions-column" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    key: 0,
    class: "no-results-message"
};
const _hoisted_24 = { class: "pagination-controls" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_TagIcon = _resolveComponent("TagIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Header "),
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" Sidebar "),
            _createVNode(_component_Sidebar),
            _createCommentVNode(" Main Content "),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    ($setup.hasPermission('PROD_CREATE'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => ($setup.goToAdd && $setup.goToAdd(...args))),
                            class: "btn btn-add"
                        }, [
                            _createVNode(_component_PlusIcon, { size: 18 }),
                            _hoisted_5
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.searchQuery) = $event)),
                            placeholder: "Buscar producto...",
                            class: "search-input"
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $setup.searchQuery]
                        ])
                    ])
                ]),
                _createCommentVNode(" Table to display productos "),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedProductos, (producto) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: producto.id
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("img", {
                                            src: $setup.getImagenPortada(producto.imagenes),
                                            alt: `Imagen de ${producto.nombre}`,
                                            class: "product-image"
                                        }, null, 8 /* PROPS */, _hoisted_13)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(producto.nombre), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(producto.codigoBarrasReferencia || 'N/A'), 1 /* TEXT */),
                                    _createElementVNode("td", null, _toDisplayString(producto.codigoUnico), 1 /* TEXT */),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("span", _hoisted_15, _toDisplayString($setup.formatCurrency(producto.precioVenta)), 1 /* TEXT */),
                                            (producto.tienePromocion)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                    _createVNode(_component_TagIcon, { size: 10 }),
                                                    _createTextVNode(" -" + _toDisplayString(producto.porcentajeDescuento) + "% ", 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("label", _hoisted_17, [
                                            _createElementVNode("input", {
                                                type: "checkbox",
                                                checked: producto.activo,
                                                onChange: ($event) => ($setup.toggleActivo(producto.id))
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18),
                                            _hoisted_19
                                        ])
                                    ]),
                                    _createElementVNode("td", _hoisted_20, [
                                        ($setup.hasPermission('PROD_EDIT'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: ($event) => ($setup.editProducto(producto.id)),
                                                class: "btn btn-icon btn-edit",
                                                title: "Editar producto"
                                            }, [
                                                _createVNode(_component_EditIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_21))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.hasPermission('PROD_DELETE'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: ($event) => ($setup.deleteProducto(producto.id)),
                                                class: "btn btn-icon btn-delete",
                                                title: "Eliminar producto"
                                            }, [
                                                _createVNode(_component_TrashIcon, { size: 18 })
                                            ], 8 /* PROPS */, _hoisted_22))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _createCommentVNode(" No resultados "),
                    (!$setup.isLoading && $setup.paginatedProductos.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " No hay productos disponibles "))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                            disabled: $setup.currentPage === 1,
                            class: "btn-pagination"
                        }, "Anterior", 8 /* PROPS */, _hoisted_25),
                        _createElementVNode("span", null, "Página " + _toDisplayString($setup.currentPage) + " de " + _toDisplayString($setup.totalPages), 1 /* TEXT */),
                        _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                            disabled: $setup.currentPage === $setup.totalPages,
                            class: "btn-pagination"
                        }, "Siguiente", 8 /* PROPS */, _hoisted_26)
                    ])
                ])
            ])
        ])
    ]));
}
